export const alertTypes = {
    SUCCESS: 0,
    ERROR: 1,
    INFO: 2
};



// WEBPACK FOOTER //
// ./src/vars.js